//
import ProductModel from '@/models/Warehouse/WhProduct'

/**
 *
 */
const fetchSuggestUPC = async () => {
    //
    try {
        //
        const response = await ProductModel.find( 'suggest_upc_code' )
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchSuggestUPC
